import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {HomeComponent} from "./home.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/company/:id/home', {template: ''});
    }]);
/***/

const homeRoutes: Routes = [
    {path: 'company/:id/home', component: HomeComponent},
    {path: 'cars-sara-v2/web/company/:id/home', component: HomeComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(homeRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class HomeRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/home/home-routing.module.ts